import * as React from "react";

export const UpcomingAppointmentInformation = ({width = "calc(100% - 32px)"}) => {
    return (
        <div
            style={{
                width: width,
                marginTop: "16px",
                borderRadius: "12px",
                padding: "16px",
                background: "#f9f9f9",
                border: "1px solid #AAAAAA",
            }}
            className="instructions"
        >
            <p style={{fontSize: "18px", fontWeight: "600"}}>
                Please Ensure:
            </p>
            <div
                style={{
                    display: "flex",
                    gap: "16px",
                    margin: "16px 0px",
                    alignItems: "center",
                }}
            >
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#clip0_340_4722)">
                        <path
                            d="M18.2461 15.8765C17.462 15.1024 16.4832 15.1024 15.7041 15.8765C15.1098 16.4658 14.5155 17.0551 13.9312 17.6544C13.7713 17.8192 13.6365 17.8542 13.4417 17.7443C13.0572 17.5345 12.6477 17.3647 12.2781 17.135C10.5551 16.0513 9.11178 14.6579 7.83327 13.0897C7.19901 12.3106 6.63467 11.4766 6.24013 10.5377C6.16023 10.3479 6.17521 10.2231 6.33003 10.0683C6.92434 9.49393 7.50366 8.90461 8.08798 8.3153C8.90203 7.49626 8.90203 6.53737 8.08298 5.71334C7.61853 5.24388 7.15407 4.78442 6.68961 4.31497C6.21017 3.83553 5.73572 3.35109 5.25129 2.87664C4.4672 2.11254 3.48834 2.11254 2.70925 2.88164C2.10995 3.47095 1.53562 4.07525 0.926333 4.65457C0.361991 5.18895 0.0773229 5.84318 0.0173928 6.60729C-0.0774965 7.85084 0.227148 9.02447 0.656647 10.1681C1.53562 12.5354 2.87406 14.6379 4.49717 16.5657C6.68961 19.1726 9.30656 21.2352 12.368 22.7235C13.7464 23.3927 15.1747 23.9071 16.7279 23.992C17.7967 24.0519 18.7256 23.7823 19.4697 22.9482C19.9791 22.3789 20.5534 21.8595 21.0928 21.3151C21.8919 20.5061 21.8969 19.5272 21.1028 18.7282C20.1539 17.7743 19.2 16.8254 18.2461 15.8765ZM17.2922 11.8961L19.1351 11.5815C18.8454 9.88847 18.0464 8.35525 16.8328 7.13668C15.5493 5.85317 13.9262 5.04412 12.1383 4.79441L11.8786 6.64725C13.2619 6.84202 14.5205 7.46629 15.5143 8.46013C16.4532 9.39904 17.0675 10.5877 17.2922 11.8961ZM20.1739 3.88547C18.0464 1.75795 15.3545 0.414517 12.383 0L12.1233 1.85284C14.6903 2.21242 17.0176 3.37606 18.8554 5.20892C20.5984 6.95189 21.742 9.15432 22.1566 11.5765L23.9994 11.2619C23.515 8.45514 22.1915 5.90811 20.1739 3.88547Z"
                            fill="url(#paint0_linear_340_4722)"
                        />
                    </g>
                    <defs>
                        <linearGradient
                            id="paint0_linear_340_4722"
                            x1="11.9997"
                            y1="0"
                            x2="11.9997"
                            y2="24"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#179D82"/>
                            <stop offset="1" stop-color="#0B7963"/>
                        </linearGradient>
                        <clipPath id="clip0_340_4722">
                            <rect width="24" height="24" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
                <p
                    style={{
                        color: "#161616",
                        fontSize: "12px",
                        fontWeight: "500",
                    }}
                >
                    You’re available on the phone for coordination
                </p>
            </div>
            {" "}
            <div
                style={{
                    display: "flex",
                    gap: "16px",
                    margin: "16px 0px",
                    alignItems: "center",
                }}
            >
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M17.1261 4.68899H21.2776L16.9082 0.397461V4.47134C16.9082 4.59128 17.0059 4.68899 17.1261 4.68899Z"
                        fill="url(#paint0_linear_340_4727)"
                    />
                    <path
                        d="M17.1257 6.05813C16.2507 6.05813 15.5387 5.34627 15.5387 4.47125V0H4.15408C2.74549 0 1.59961 1.14588 1.59961 2.55443V20.8137C1.59961 22.2223 2.74549 23.3682 4.15408 23.3682H19.1272C20.5359 23.3682 21.6816 22.2223 21.6816 20.8137V6.05809L17.1257 6.05813ZM15.5607 17.7087H6.74276C6.36467 17.7087 6.05815 17.4022 6.05815 17.0241C6.05815 16.646 6.36467 16.3395 6.74276 16.3395H15.5607C15.939 16.3395 16.2454 16.646 16.2454 17.0241C16.2454 17.4022 15.939 17.7087 15.5607 17.7087ZM6.05815 14.2856C6.05815 13.9075 6.36467 13.601 6.74276 13.601H14.6116C14.9899 13.601 15.2962 13.9075 15.2962 14.2856C15.2962 14.6637 14.9895 14.9702 14.6116 14.9702H6.74276C6.36467 14.9702 6.05815 14.6637 6.05815 14.2856ZM16.3933 12.2318H6.74276C6.36467 12.2318 6.05815 11.9253 6.05815 11.5472C6.05815 11.1691 6.36467 10.8626 6.74276 10.8626H16.3933C16.7714 10.8626 17.0779 11.1691 17.0779 11.5472C17.0779 11.9253 16.7714 12.2318 16.3933 12.2318Z"
                        fill="url(#paint1_linear_340_4727)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_340_4727"
                            x1="19.0929"
                            y1="0.397461"
                            x2="19.0929"
                            y2="4.68899"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#179D82"/>
                            <stop offset="1" stop-color="#0B7963"/>
                        </linearGradient>
                        <linearGradient
                            id="paint1_linear_340_4727"
                            x1="11.6406"
                            y1="0"
                            x2="11.6406"
                            y2="23.3682"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#179D82"/>
                            <stop offset="1" stop-color="#0B7963"/>
                        </linearGradient>
                    </defs>
                </svg>

                <p
                    style={{
                        color: "#161616",
                        fontSize: "12px",
                        fontWeight: "500",
                    }}
                >
                    The patient and test reports are ready (of any)
                </p>
            </div>
            {" "}
            <div
                style={{
                    display: "flex",
                    gap: "16px",
                    margin: "16px 0px",
                    alignItems: "center",
                }}
            >
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#clip0_340_4733)">
                        <path
                            d="M22.9453 4.80002L22.4362 4.36365C22.509 4.03638 22.3999 3.63638 22.1453 3.23638C21.8908 2.87274 21.5271 2.50911 21.2362 2.36365C20.5817 2.03638 19.7453 2.32729 19.3817 3.09093C19.018 3.8182 19.2726 4.69093 19.9635 5.0182C20.218 5.12729 20.5817 5.23638 20.9817 5.23638C21.3453 5.23638 21.7453 5.16365 22.0362 4.98183L22.4726 5.38183C23.018 5.85456 23.0544 6.69093 22.5817 7.20002L19.418 10.4C18.8726 10.1091 18.1817 10.2182 17.7453 10.6909C16.618 11.8909 15.1271 11.7455 14.1817 11.2364C13.1271 10.6546 12.6544 9.63638 12.9453 8.43638C13.018 8.07274 12.9453 7.67274 12.7635 7.34547C12.618 7.12729 12.3999 6.94547 12.1453 6.83638C12.218 6.32729 11.9271 8.54547 12.7271 2.50911C12.8726 1.8182 13.5635 1.34547 14.2544 1.49093L14.9817 1.63638C15.018 1.85456 15.1271 2.10911 15.2726 2.36365C15.5271 2.72729 15.8544 3.09093 16.1817 3.23638C16.8726 3.56365 17.709 3.23638 18.0362 2.50911C18.3999 1.78183 18.1453 0.909108 17.4544 0.581835C16.8726 0.290926 15.5635 0.254562 15.0908 0.909108L14.3271 0.763653C13.2362 0.545471 12.1817 1.23638 11.9271 2.32729V2.40002L11.3453 6.69093C11.1271 6.72729 10.8726 6.80002 10.6908 6.90911C10.3635 7.12729 10.1453 7.4182 10.0726 7.8182C9.59986 9.92729 10.2544 11.8546 11.818 13.1273C11.6726 13.5273 11.5271 13.9273 11.3817 14.2909C10.5453 14.0364 9.81805 13.8546 9.1635 13.6727C7.45441 13.2364 5.45441 12.8 3.59987 13.5637C0.581685 14.7637 -0.618315 18.5455 1.23623 21.3455C2.7635 23.6364 5.67259 24.1818 8.10896 23.1273C9.5635 22.4727 10.8726 21.2727 11.8908 19.6364C12.218 19.1273 12.5817 18.4 12.9817 17.4182C14.218 17.8182 16.218 18.4727 17.418 18.8727C17.5635 20.2909 18.7635 21.3818 20.218 21.3818C21.7817 21.3818 23.018 20.1091 23.018 18.5455C23.018 16.9818 21.7453 15.7091 20.218 15.7091C19.4908 15.7091 18.8362 16 18.3271 16.4364C17.1271 16 15.1635 15.3818 13.9271 14.9818C14.0362 14.7273 14.109 14.4727 14.218 14.2182C14.6544 14.3273 15.1271 14.3637 15.5999 14.3637C17.1635 14.3637 18.6908 13.7455 19.818 12.5818C20.0726 12.2909 20.218 11.9273 20.218 11.5637C20.218 11.3091 20.1453 11.0546 19.9999 10.8364L23.1635 7.63638C23.8544 6.83638 23.7817 5.56365 22.9453 4.80002ZM9.9635 18.4364C9.41805 19.3091 8.50896 20.4727 7.1635 21.0546C5.74532 21.6727 3.9635 21.4909 3.01805 20.0727C1.9635 18.4727 2.65441 16.2546 4.43623 15.5273C5.70896 15.0182 7.30896 15.3818 8.61805 15.7455C9.38168 15.9637 10.1453 16.1455 10.909 16.4C10.5453 17.3091 10.218 18 9.9635 18.4364ZM20.218 17.2C20.9817 17.2 21.5635 17.8182 21.5635 18.5455C21.5635 19.2727 20.9453 19.8909 20.218 19.8909C19.4544 19.8909 18.8726 19.2727 18.8726 18.5455C18.8726 17.8182 19.4544 17.2 20.218 17.2Z"
                            fill="url(#paint0_linear_340_4733)"
                        />
                    </g>
                    <defs>
                        <linearGradient
                            id="paint0_linear_340_4733"
                            x1="11.9929"
                            y1="0.382324"
                            x2="11.9929"
                            y2="23.6435"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#179D82"/>
                            <stop offset="1" stop-color="#0B7963"/>
                        </linearGradient>
                        <clipPath id="clip0_340_4733">
                            <rect width="24" height="24" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>

                <p
                    style={{
                        color: "#161616",
                        fontSize: "12px",
                        fontWeight: "500",
                    }}
                >
                    There’s a quiet space for the check-up
                </p>
            </div>
            {" "}
            <div
                style={{
                    display: "flex",
                    gap: "16px",
                    margin: "16px 0px",
                    alignItems: "center",
                }}
            >
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7 11.5C4.5 11.5 2.5 9.5 2.5 7C2.5 4.5 4.5 2.5 7 2.5C9.5 2.5 11.5 4.5 11.5 7C11.5 9.5 9.5 11.5 7 11.5ZM17.5 15.5C15.3 15.5 13.5 13.7 13.5 11.5C13.5 9.3 15.3 7.5 17.5 7.5C19.7 7.5 21.5 9.3 21.5 11.5C21.5 13.7 19.7 15.5 17.5 15.5ZM17.5 16.5C20 16.5 22 18.5 22 21V21.5H13V21C13 18.5 15 16.5 17.5 16.5ZM7 12.5C9.8 12.5 12 14.7 12 17.5V21.5H2V17.5C2 14.7 4.2 12.5 7 12.5Z"
                        fill="url(#paint0_linear_340_4738)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_340_4738"
                            x1="12"
                            y1="2.5"
                            x2="12"
                            y2="21.5"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stop-color="#179D82"/>
                            <stop offset="1" stop-color="#0B7963"/>
                        </linearGradient>
                    </defs>
                </svg>

                <p
                    style={{
                        color: "#161616",
                        fontSize: "12px",
                        fontWeight: "500",
                    }}
                >
                    A family member i present for female or under -18 patients
                </p>
            </div>
        </div>
    );
};
